import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { BubbleCommand } from '../_shared/constants';
import { BubbleChannel } from '../client/src/modules/_core/components/BubbleChannel';
import { HeaderClass } from '../client/src/modules/_core/components/Header/Header';
import { PageHome } from '../client/src/modules/_core/components/PageHome/PageHome';
import { config } from '../client/src/modules/_core/config';
import { url } from '../client/src/modules/_core/url';
import { I18nMsgNs } from '../client/src/modules/_core/utils/i18n-helpers';
import { TextMessageClass } from '../client/src/modules/chat/components/Messages/TextMessage';
import { dataLayerPush } from './utils';
import { Fullscreen, FullscreenExit } from '@mui/icons-material';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { alertModal } from '../client/src/modules/domain/app-modal';
import ModalComp from '../client/src/modules/chat/components/Modal/Modal';
import CloseReviewWidget from './eon-digital-human/components/CloseReviewWidget';
import { ChatThreadClass } from '../client/src/modules/chat/components/ChatThread/ChatThread';
import { CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER } from '../client/src/consts';
import { ChatMessageType } from '../client/src/_library/domain-base/BaseChatMessage';
import { PageChatClass } from '../client/src/modules/_core/components/PageChat/PageChat';
import { getSessionThreadId, removeSessionThreadId, setSessionTheadId } from '../client/src/modules/_core/utils/app-storage';
export var initializeExternals = function (clientConfig) {
    var B = config.css.B('-header');
    var isFullscreen = false;
    var isExpand = false;
    PageChatClass.threadIdHandler = function (cmp, threadId, prevThreadId) {
        if (threadId !== prevThreadId && clientConfig.MAINTAIN_SESSION) {
            removeSessionThreadId();
            setSessionTheadId(threadId);
        }
        var isOpen = JSON.parse(sessionStorage.getItem('bubble-isOpen')) || {};
        var isShown = JSON.parse(sessionStorage.getItem('bubble-isShown')) || {};
        if (isOpen.payload && isShown.payload && clientConfig.MAINTAIN_SESSION)
            setSessionTheadId(threadId);
    };
    PageHome.getInitialRoute = function () {
        var threadId = getSessionThreadId();
        if (threadId && clientConfig.MAINTAIN_SESSION) {
            return url.CHAT(threadId);
        }
        else {
            return url.CHAT();
        }
    };
    TextMessageClass.messageTimestampFormatter = function (message, cmp) {
        var d = new Date(message.created);
        var pad = function (v) { return (v < 10 ? "0".concat(v) : v); };
        return pad(d.getHours()) + ':' + pad(d.getMinutes());
    };
    HeaderClass.rendererLeftBox = function (cmp) {
        var toggleFullscreen = function (e) {
            e.preventDefault();
            if (!isFullscreen)
                isExpand = false;
            isFullscreen = !isFullscreen;
            BubbleChannel.postCommand(BubbleCommand.OPEN_FULLSCREEN_TOGGLE);
        };
        var toggleExpand = function (e) {
            e.preventDefault();
            if (!isExpand)
                isFullscreen = false;
            isExpand = !isExpand;
            BubbleChannel.postCommand(BubbleCommand.OPEN_EXPAND_TOGGLE);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: "".concat(B, "__boxbutton minimize-icon"), onClick: function (e) {
                    BubbleChannel.postCommand(BubbleCommand.CLOSE, { minimize: true });
                } },
                React.createElement(BytesizeIcon, { name: "minimize", size: "small", thickness: "medium" })),
            React.createElement("button", { className: "".concat(B, "__boxbutton fullscreen-icon ").concat(isFullscreen ? 'fullscreen-on' : ''), onClick: toggleFullscreen }, isFullscreen ? React.createElement(FullscreenExit, null) : React.createElement(Fullscreen, null)),
            React.createElement("button", { className: "".concat(B, "__boxbutton expand-icon ").concat(isExpand ? 'expand-on' : ''), onClick: toggleExpand })));
    };
    HeaderClass.rendererRightBox = function (cmp) {
        var B = config.css.B('-header');
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: "".concat(B, "__boxbutton info-icon"), onClick: function () {
                    return alertModal(cmp.props.dispatch, {
                        title: 'Alert',
                        body: (React.createElement("div", { dangerouslySetInnerHTML: {
                                __html: cmp.props.intl.formatMessage({
                                    id: 'infoAlert.body',
                                }),
                            } })),
                        labelOK: cmp.props.intl.formatMessage({ id: 'infoAlert.ok' }),
                    });
                } },
                React.createElement(BytesizeIcon, { name: "info", size: "small", thickness: "light" })),
            React.createElement(Link, { className: "".concat(B, "__boxbutton refresh-icon"), to: url.HOME() }),
            React.createElement("button", { className: "".concat(B, "__boxbutton menu-icon") }),
            React.createElement("button", { className: "".concat(B, "__boxbutton close-icon"), onClick: function (e) {
                    if (clientConfig.CLIENT_EXTERNAL === 'eon-digital-human') {
                        cmp.setModalContent((React.createElement(CloseReviewWidget, { handleSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                                var _a, dispatch, identity, threadId;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = cmp.props, dispatch = _a.dispatch, identity = _a.identity, threadId = _a.threadId;
                                            return [4 /*yield*/, ChatThreadClass.submitMessage({ dispatch: dispatch, identity: identity, threadId: threadId }, JSON.stringify({
                                                    type: CUSTOM_MESSAGE_TYPE_MARKER,
                                                    room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                                                    payload: values
                                                }), ChatMessageType.HIDDEN)];
                                        case 1:
                                            _b.sent();
                                            ChatThreadClass.submitMessage({ dispatch: dispatch, identity: identity, threadId: threadId }, ':call_end_customer_hangup', ChatMessageType.HIDDEN);
                                            cmp._handleCloseClick(e);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, handleCancel: function () {
                                cmp.handleCloseModal();
                            } })));
                        cmp.handleOpenModal();
                    }
                    else {
                        cmp._handleCloseClick(e);
                    }
                } },
                React.createElement(BytesizeIcon, { name: "close", size: "small", thickness: "medium" })),
            React.createElement(ModalComp, { isModalOpen: cmp.isModalOpen, handleClose: function () { return cmp.handleCloseModal(); }, content: cmp.modalContent, hideFooter: true })));
    };
    PageHome.rendererMain = function (cmp) {
        var Msg = I18nMsgNs('PageHome');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "gaid-page-home__texts" },
                React.createElement("h1", null,
                    React.createElement(Msg, { id: "startWelcome" })),
                React.createElement("p", null,
                    React.createElement(Msg, { id: "startWelcomeDesc" }))),
            React.createElement("div", { className: "gaid-page-home__buttonwrap" },
                React.createElement(Button, { color: "primary", onClick: function () {
                        PageHome.onStartNewClick();
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({
                            eventAction: 'RedButton',
                            eventLabel: 'Zacat Chat',
                        });
                    } },
                    React.createElement(Msg, { id: "startNew" })),
                React.createElement("div", { className: "gaid-page-home__footer" }, "powered by " + clientConfig.POWERED_BY_TEXT))));
    };
};
